import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { PhoneIcon, MailIcon, CalendarIcon, ClockIcon, MessageCircleIcon, StarIcon, ArrowRightIcon, CheckCircleIcon, UserIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function ConsultantContactPage() {
  // Available time slots
  const timeSlots = [{
    day: 'Lundi',
    date: '5 Juin',
    slots: ['09:00', '11:30', '14:00', '16:30']
  }, {
    day: 'Mardi',
    date: '6 Juin',
    slots: ['09:00', '11:30', '15:00', '17:00']
  }, {
    day: 'Mercredi',
    date: '7 Juin',
    slots: ['10:00', '12:00', '14:30', '16:00']
  }, {
    day: 'Jeudi',
    date: '8 Juin',
    slots: ['09:30', '11:00', '14:00', '16:30']
  }, {
    day: 'Vendredi',
    date: '9 Juin',
    slots: ['10:00', '13:00', '15:30', '17:00']
  }];
  // Consultant team
  const consultants = [{
    name: 'Ahmed Benali',
    role: 'Expert BTP & Construction',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    experience: "15+ ans d'expérience",
    expertise: ['Marchés publics de construction', 'Infrastructures', 'Génie civil'],
    languages: ['Français', 'Arabe', 'Anglais']
  }, {
    name: 'Leila Mansouri',
    role: 'Juriste Marchés Publics',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    experience: "12+ ans d'expérience",
    expertise: ['Réglementation des marchés publics', 'Conformité administrative', 'Contentieux'],
    languages: ['Français', 'Arabe', 'Anglais']
  }, {
    name: 'Karim Zouaoui',
    role: 'Expert IT & Télécoms',
    image: 'https://randomuser.me/api/portraits/men/75.jpg',
    experience: "10+ ans d'expérience",
    expertise: ['Solutions informatiques', 'Télécommunications', 'Infrastructures IT'],
    languages: ['Français', 'Arabe', 'Anglais']
  }];
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-1649">
      <Navbar data-id="element-1650" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden" data-id="element-1651">
        <div className="container mx-auto px-4 relative z-10" data-id="element-1652">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1653">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-1654">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1655">
                Consultation gratuite
              </span>
              <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6" data-id="element-1656">
                Parlez à un conseiller expert
              </h1>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-1657">
                Planifiez un appel avec l'un de nos conseillers experts pour
                discuter de vos besoins spécifiques et découvrir comment notre
                assistance Premium peut vous aider à maximiser vos chances de
                succès.
              </p>
            </motion.div>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-yellow-100 to-transparent opacity-70" data-id="element-1658"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-radial from-blue-50 to-transparent opacity-70" data-id="element-1659"></div>
      </section>
      {/* Main Content Section */}
      <section className="py-16" data-id="element-1660">
        <div className="container mx-auto px-4" data-id="element-1661">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-1662">
            {/* Booking Form */}
            <motion.div className="lg:w-7/12" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-1663">
              <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-200" data-id="element-1664">
                <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-1665">
                  Planifiez votre consultation
                </h2>
                <form className="space-y-6" data-id="element-1666">
                  {/* Personal Information */}
                  <div className="space-y-4" data-id="element-1667">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-1668">
                      <UserIcon size={20} className="mr-2 text-blue-600" data-id="element-1669" />
                      Informations personnelles
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1670">
                      <div data-id="element-1671">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1672">
                          Prénom
                        </label>
                        <input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Votre prénom" data-id="element-1673" />
                      </div>
                      <div data-id="element-1674">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1675">
                          Nom
                        </label>
                        <input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Votre nom" data-id="element-1676" />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1677">
                      <div data-id="element-1678">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1679">
                          Email professionnel
                        </label>
                        <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="votre@email.com" data-id="element-1680" />
                      </div>
                      <div data-id="element-1681">
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1682">
                          Téléphone
                        </label>
                        <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="+33 X XX XX XX XX" data-id="element-1683" />
                      </div>
                    </div>
                    <div data-id="element-1684">
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1685">
                        Entreprise
                      </label>
                      <input type="text" id="company" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Nom de votre entreprise" data-id="element-1686" />
                    </div>
                  </div>
                  {/* Consultation Details */}
                  <div className="space-y-4" data-id="element-1687">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-1688">
                      <CalendarIcon size={20} className="mr-2 text-blue-600" data-id="element-1689" />
                      Détails de la consultation
                    </h3>
                    <div data-id="element-1690">
                      <label htmlFor="topic" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1691">
                        Sujet de la consultation
                      </label>
                      <select id="topic" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-1692">
                        <option value="" data-id="element-1693">Sélectionnez un sujet</option>
                        <option value="pricing" data-id="element-1694">
                          Informations sur les tarifs
                        </option>
                        <option value="features" data-id="element-1695">
                          Fonctionnalités de l'assistance Premium
                        </option>
                        <option value="custom" data-id="element-1696">
                          Solution personnalisée pour mon entreprise
                        </option>
                        <option value="demo" data-id="element-1697">
                          Démonstration de la plateforme
                        </option>
                        <option value="other" data-id="element-1698">Autre sujet</option>
                      </select>
                    </div>
                    <div data-id="element-1699">
                      <label htmlFor="sector" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1700">
                        Secteur d'activité
                      </label>
                      <select id="sector" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-1701">
                        <option value="" data-id="element-1702">Sélectionnez un secteur</option>
                        <option value="construction" data-id="element-1703">BTP & Construction</option>
                        <option value="it" data-id="element-1704">Technologies & Télécoms</option>
                        <option value="health" data-id="element-1705">Santé & Pharmaceutique</option>
                        <option value="energy" data-id="element-1706">Énergie & Utilities</option>
                        <option value="services" data-id="element-1707">Services & Conseil</option>
                        <option value="other" data-id="element-1708">Autre secteur</option>
                      </select>
                    </div>
                    <div data-id="element-1709">
                      <label htmlFor="consultant" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1710">
                        Conseiller souhaité (optionnel)
                      </label>
                      <select id="consultant" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-1711">
                        <option value="" data-id="element-1712">
                          N'importe quel conseiller disponible
                        </option>
                        {consultants.map((consultant, index) => <option key={index} value={consultant.name.toLowerCase().replace(' ', '-')} data-id="element-1713">
                            {consultant.name} - {consultant.role}
                          </option>)}
                      </select>
                    </div>
                    <div data-id="element-1714">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1715">
                        Message (optionnel)
                      </label>
                      <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Précisez vos besoins ou questions spécifiques..." data-id="element-1716"></textarea>
                    </div>
                  </div>
                  {/* Time Slots */}
                  <div className="space-y-4" data-id="element-1717">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-1718">
                      <ClockIcon size={20} className="mr-2 text-blue-600" data-id="element-1719" />
                      Choisissez un créneau horaire
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-1720">
                      {timeSlots.map((daySlot, dayIndex) => <div key={dayIndex} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1721">
                          <div className="bg-blue-50 px-3 py-2 text-center border-b border-gray-200" data-id="element-1722">
                            <p className="font-medium text-blue-900" data-id="element-1723">
                              {daySlot.day}
                            </p>
                            <p className="text-sm text-gray-600" data-id="element-1724">
                              {daySlot.date}
                            </p>
                          </div>
                          <div className="p-3 space-y-2" data-id="element-1725">
                            {daySlot.slots.map((time, timeIndex) => <button key={timeIndex} type="button" className="w-full px-3 py-2 text-sm border border-gray-200 rounded hover:bg-blue-50 hover:border-blue-300 transition-colors" data-id="element-1726">
                                {time}
                              </button>)}
                          </div>
                        </div>)}
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="pt-4" data-id="element-1727">
                    <Button variant="primary" fullWidth className="shadow-lg" data-id="element-1728">
                      Planifier ma consultation
                    </Button>
                    <p className="text-center text-sm text-gray-500 mt-4" data-id="element-1729">
                      En cliquant sur ce bouton, vous acceptez notre politique
                      de confidentialité et nos conditions d'utilisation.
                    </p>
                  </div>
                </form>
              </div>
            </motion.div>
            {/* Sidebar */}
            <div className="lg:w-5/12" data-id="element-1730">
              {/* What to Expect */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-8" data-id="element-1731">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1732">
                  À quoi s'attendre
                </h3>
                <div className="space-y-4" data-id="element-1733">
                  <div className="flex" data-id="element-1734">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 flex-shrink-0" data-id="element-1735">
                      <span className="font-semibold" data-id="element-1736">1</span>
                    </div>
                    <div data-id="element-1737">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1738">
                        Consultation personnalisée de 30 minutes
                      </h4>
                      <p className="text-gray-600 text-sm" data-id="element-1739">
                        Un appel individuel avec l'un de nos conseillers experts
                        pour discuter de vos besoins spécifiques.
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1740">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 flex-shrink-0" data-id="element-1741">
                      <span className="font-semibold" data-id="element-1742">2</span>
                    </div>
                    <div data-id="element-1743">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1744">
                        Analyse de vos besoins
                      </h4>
                      <p className="text-gray-600 text-sm" data-id="element-1745">
                        Notre conseiller évaluera vos besoins et vous
                        recommandera les solutions les plus adaptées.
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1746">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 flex-shrink-0" data-id="element-1747">
                      <span className="font-semibold" data-id="element-1748">3</span>
                    </div>
                    <div data-id="element-1749">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1750">
                        Présentation des offres
                      </h4>
                      <p className="text-gray-600 text-sm" data-id="element-1751">
                        Découvrez nos différentes formules d'assistance Premium
                        et leurs avantages pour votre entreprise.
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-1752">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 flex-shrink-0" data-id="element-1753">
                      <span className="font-semibold" data-id="element-1754">4</span>
                    </div>
                    <div data-id="element-1755">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1756">
                        Proposition personnalisée
                      </h4>
                      <p className="text-gray-600 text-sm" data-id="element-1757">
                        Recevez une proposition adaptée à vos besoins
                        spécifiques et à votre budget.
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
              {/* Our Consultants */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="bg-white rounded-xl shadow-lg border border-gray-200 p-6" data-id="element-1758">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1759">
                  Nos conseillers experts
                </h3>
                <div className="space-y-6" data-id="element-1760">
                  {consultants.map((consultant, index) => <div key={index} className="flex" data-id="element-1761">
                      <img src={consultant.image} alt={consultant.name} className="w-16 h-16 rounded-full object-cover mr-4" data-id="element-1762" />
                      <div data-id="element-1763">
                        <h4 className="font-semibold text-gray-900" data-id="element-1764">
                          {consultant.name}
                        </h4>
                        <p className="text-blue-600 text-sm mb-1" data-id="element-1765">
                          {consultant.role}
                        </p>
                        <p className="text-gray-500 text-xs mb-2" data-id="element-1766">
                          {consultant.experience}
                        </p>
                        <div className="flex flex-wrap gap-1" data-id="element-1767">
                          {consultant.expertise.slice(0, 2).map((skill, skillIndex) => <span key={skillIndex} className="inline-block bg-blue-50 text-blue-700 text-xs px-2 py-0.5 rounded-full" data-id="element-1768">
                                {skill}
                              </span>)}
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-1769">
                  <div className="flex items-center justify-between" data-id="element-1770">
                    <div className="flex items-center text-yellow-500" data-id="element-1771">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-1772" />)}
                      <span className="ml-2 text-gray-700 text-sm font-medium" data-id="element-1773">
                        4.9/5
                      </span>
                    </div>
                    <span className="text-gray-500 text-sm" data-id="element-1774">
                      Basé sur 128 avis
                    </span>
                  </div>
                </div>
              </motion.div>
              {/* Alternative Contact Methods */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-blue-900 rounded-xl shadow-lg p-6 mt-8 text-white" data-id="element-1775">
                <h3 className="text-xl font-bold mb-4" data-id="element-1776">
                  Autres moyens de contact
                </h3>
                <p className="text-blue-100 mb-6" data-id="element-1777">
                  Si vous préférez nous contacter directement sans planifier un
                  appel, vous pouvez utiliser les options suivantes :
                </p>
                <div className="space-y-4" data-id="element-1778">
                  <div className="flex items-center" data-id="element-1779">
                    <div className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center mr-4" data-id="element-1780">
                      <PhoneIcon size={18} className="text-blue-100" data-id="element-1781" />
                    </div>
                    <div data-id="element-1782">
                      <p className="font-medium" data-id="element-1783">Par téléphone</p>
                      <a href="tel:+33753293419" className="text-blue-100" data-id="element-1784">
                        +33 7 53 29 34 19
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1785">
                    <div className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center mr-4" data-id="element-1786">
                      <MailIcon size={18} className="text-blue-100" data-id="element-1787" />
                    </div>
                    <div data-id="element-1788">
                      <p className="font-medium" data-id="element-1789">Par email</p>
                      <a href="mailto:premium@elevateit.fr" className="text-blue-100" data-id="element-1790">
                        premium@elevateit.fr
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1791">
                    <div className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center mr-4" data-id="element-1792">
                      <MessageCircleIcon size={18} className="text-blue-100" data-id="element-1793" />
                    </div>
                    <div data-id="element-1794">
                      <p className="font-medium" data-id="element-1795">Chat en direct</p>
                      <a href="#" className="text-blue-100 flex items-center" data-id="element-1796">
                        Démarrer une conversation
                        <ArrowRightIcon size={14} className="ml-1" data-id="element-1797" />
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-16 bg-gray-50" data-id="element-1798">
        <div className="container mx-auto px-4" data-id="element-1799">
          <div className="text-center mb-12" data-id="element-1800">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-1801">
              Ce que disent nos clients
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1802">
              Découvrez les témoignages de clients qui ont bénéficié de nos
              consultations personnalisées.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1803">
            {[{
            quote: 'La consultation initiale a été extrêmement utile. Le conseiller a pris le temps de comprendre nos besoins et nous a proposé une solution parfaitement adaptée à notre situation.',
            author: 'Sarah Lahmadi',
            position: 'Directrice des Opérations, Construct Plus',
            image: 'https://randomuser.me/api/portraits/women/65.jpg'
          }, {
            quote: "J'hésitais entre plusieurs formules, mais après 30 minutes de discussion avec un conseiller, j'ai eu une vision claire de ce dont mon entreprise avait besoin. Un gain de temps considérable !",
            author: 'Rachid Tazi',
            position: 'PDG, TechSolutions Maroc',
            image: 'https://randomuser.me/api/portraits/men/54.jpg'
          }, {
            quote: "Le conseiller a été très à l'écoute et nous a proposé une offre sur mesure qui correspondait parfaitement à notre budget et à nos objectifs. Très professionnel !",
            author: 'Amina Bensouda',
            position: 'Responsable Marchés Publics, MedEquip',
            image: 'https://randomuser.me/api/portraits/women/33.jpg'
          }].map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1804">
                <div className="mb-6" data-id="element-1805">
                  <svg className="h-8 w-8 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-1806">
                    <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h10zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" data-id="element-1807" />
                  </svg>
                </div>
                <p className="text-gray-700 mb-6 italic" data-id="element-1808">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center" data-id="element-1809">
                  <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4" data-id="element-1810" />
                  <div data-id="element-1811">
                    <h4 className="font-bold text-gray-900" data-id="element-1812">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1813">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16" data-id="element-1814">
        <div className="container mx-auto px-4" data-id="element-1815">
          <div className="text-center mb-12" data-id="element-1816">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-1817">
              Questions fréquentes
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1818">
              Nous avons rassemblé les questions les plus fréquentes concernant
              nos consultations avec un conseiller.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-1819">
            <div className="space-y-6" data-id="element-1820">
              {[{
              question: 'La consultation est-elle vraiment gratuite ?',
              answer: 'Oui, la consultation initiale de 30 minutes est totalement gratuite et sans engagement. Notre objectif est de comprendre vos besoins et de vous proposer la solution la plus adaptée.'
            }, {
              question: 'Comment se déroule la consultation ?',
              answer: 'La consultation se déroule par téléphone ou par visioconférence selon votre préférence. Vous recevrez un email de confirmation avec les détails de connexion après avoir planifié votre rendez-vous.'
            }, {
              question: "Puis-je changer l'horaire de ma consultation ?",
              answer: "Oui, vous pouvez modifier l'horaire de votre consultation jusqu'à 2 heures avant le rendez-vous. Il vous suffit de cliquer sur le lien de modification dans l'email de confirmation."
            }, {
              question: 'Que se passe-t-il après la consultation ?',
              answer: "Après la consultation, vous recevrez un résumé par email avec les points discutés et une proposition personnalisée. Vous êtes libre de l'accepter ou non, sans aucune obligation."
            }, {
              question: 'Puis-je demander une consultation avec un expert spécifique ?',
              answer: "Oui, vous pouvez demander un conseiller spécifique en fonction de votre secteur d'activité ou de vos besoins particuliers. Nous ferons notre possible pour répondre à votre demande en fonction des disponibilités."
            }].map((faq, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1821">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1822">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600" data-id="element-1823">{faq.answer}</p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-blue-900 text-white" data-id="element-1824">
        <div className="container mx-auto px-4" data-id="element-1825">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1826">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1827">
              Prêt à découvrir comment nous pouvons vous aider ?
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-1828">
              Planifiez votre consultation gratuite dès aujourd'hui et découvrez
              comment notre assistance Premium peut maximiser vos chances de
              succès.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1829">
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20 bg-yellow-500 hover:bg-yellow-400 text-blue-900" data-id="element-1830">
                Planifier ma consultation
              </Button>
              <Link to="/premium-offers" data-id="element-1831">
                <Button variant="secondary" size="lg" className="bg-white text-blue-900 hover:bg-blue-50" data-id="element-1832">
                  Découvrir nos offres
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-1833" />
      <FloatingCTA data-id="element-1834" />
    </div>;
}